import { render, staticRenderFns } from "./POD-10Report.vue?vue&type=template&id=2e076cbd&scoped=true&"
import script from "./POD-10Report.vue?vue&type=script&lang=js&"
export * from "./POD-10Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e076cbd",
  null
  
)

export default component.exports